import React from "react";
import "./headline.m.css";

export default function Headline({ headline }) {
  return <h1 styleName="headline">{ headline }</h1>;
}
